module.exports = __webpack_public_path__ + "img/clouds.848b3b1b.jpg";